'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _imageDetail = require('./imageDetail.html');

var _imageDetail2 = _interopRequireDefault(_imageDetail);

var _imageDetail3 = require('./imageDetail.controller');

var _imageDetail4 = _interopRequireDefault(_imageDetail3);

require('./imageDetail.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageDetailComponent = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  template: _imageDetail2.default,
  controller: _imageDetail4.default,
  controllerAs: "vm"
};

exports.default = imageDetailComponent;


// WEBPACK FOOTER //
// ./client/app/common/imageDetail/imageDetail.component.js